import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";

function TaticalAnalysisMobile({ config }) {
  const { t } = useTranslation();
  const { cards } = config.overview;

  return (
    <iframe
      width={"100%"}
      height={"100%"}
      src="https://mtrix-pad-tatico.mtrix.com.br"
    ></iframe>
  );
}

TaticalAnalysisMobile.defaultProps = {
  app: null,
  config: {},
};

TaticalAnalysisMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default TaticalAnalysisMobile;
